import '../css/acercaDeMi.css'
import img from '../img/WhatsApp-Image-2025-12-27-at-15.08.24.webp'



const AcercaDeMi = () => {
  return (
    <div className="sectionAcercaDeMi">
      <div className="introAcercaDeMi">
        <img className='imgAcercaDeMi' src={img}/>
        
        <p className='acercaDeMiText'>Mi camino en el arte no fue inmediato, pero sí inevitable. En un comienzo, seguí el mandato familiar de estudiar Derecho, como tantas veces ocurría en otras épocas, cuando se creía que un título universitario era sinónimo de estabilidad y éxito. Esa elección respondió a expectativas ajenas, a una forma de entender la vida que priorizaba la seguridad por sobre la vocación.

          Sin embargo, con el tiempo, comprendí que esa no era mi verdadera senda. La vida, con sus giros inesperados, me fue revelando poco a poco lo que ya habitaba en mí: una necesidad profunda de expresarme, de crear, de mirar el mundo desde otra sensibilidad. Escuché, por fin, esa voz interior que siempre había estado allí, hablándome en silencio.

          Comencé entonces un camino de formación con maestros generosos y exigentes, y me sumergí con pasión en talleres, cursos y estudios de Historia del Arte. Cada aprendizaje no solo me acercaba a las técnicas y a los lenguajes del arte, sino que me transformaba, me revelaba, me daba una nueva manera de habitar el mundo.

          Hoy, puedo decir con certeza que encontré mi lugar. El arte no es simplemente una profesión ni una elección racional: es mi manera de existir. Pinto, grabo y dibujo porque en esas acciones encuentro sentido, encuentro paz, encuentro verdad. Crear es para mí un acto de libertad y también de honestidad: una forma de decir quién soy sin necesidad de palabras.</p>
      </div>
    </div>
  )
}

export default AcercaDeMi